import { Navigate, Outlet } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';
import { PRIVATE } from 'Shared/Routing/Application/Constants/PathsConstant';

export default function PermissionRoute({ permission }) {
  const { checkPermission, isAdmin } = useAuthContext();
  const permissions = Array.isArray(permission) ? permission : [permission];

  if (!isAdmin() && !permissions.some((currentPermission) => checkPermission(currentPermission))) {
    return <Navigate to={PRIVATE} />;
  }

  return <Outlet />;
}

PermissionRoute.propTypes = {
  permission: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]).isRequired
};
